import React, { useEffect, useState } from "react";
import { RQUseQuery } from "../components/RQUseQueryHook.ts";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  useTheme,
} from "@mui/material";
import { getCountry } from "../functions/getCountry.ts";
import { useMediaQuery } from "react-responsive";

const generateType = (title: string) => {
  switch (title) {
    case "Gold Ounce":
      return "اونس طلا";
    case "Gold Gram":
      return "طلای گرمی";
    case "Gold Mithqal":
      return "مثقال طلا";
    case "Coin Emami":
      return "سکه امامی";
    case "Euro / IRR":
      return "یورو";
    case "US Dollar / IRR":
      return "دلار آمریکا";
    case "Bitcoin":
      return "بیت کوین";

    default:
      break;
  }
};
const currencyType = (title: string) => {
  if (title === "Gold Ounce" || title === "Bitcoin") {
    return "دلار";
  } else {
    return "تومان";
  }
};
const tblRow1 = ["نماد ارز", "نوع ارز", "خرید", "فروش"];
const tblRow2 = ["نوع سکه", "خرید", "فروش"];
const styles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  gridView: {
    display: "grid",
    gridTemplateColumns: "15% 15% 15%  15% 15% ",
    rowGap: "2rem",
    width: "100%",
    columnGap: "1rem",
    height: "fit-content",
    justifyContent: "center",
    margin: "2rem 0rem",
  },
  gridViewMobile: {
    display: "grid",
    gridTemplateColumns: "30% 30% 30% ",
    rowGap: "2rem",
    width: "100%",
    columnGap: "1rem",
    height: "fit-content",
    justifyContent: "center",
    margin: "2rem 0rem",
  },
  currencyGridView: {
    display: "flex",
    width: "100%",
  },
  currencyGridViewMobile: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  flexContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
};
function Bonbast() {
  const [isSuccuss, setIsSuccuss] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);

  const theme = useTheme();
  const onSuccess = (data) => {
    setIsSuccuss(true);
  };
  const onError = (err) => {
    console.log(err);
  };
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isTablet = useMediaQuery({
    query: "((min-width:650px) and (max-width: 900px))",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });
  const { data } = RQUseQuery(
    `${process.env.REACT_APP_BASE_URL}/BonBast/GetAll_Data_BonBast`,
    "BonbastRates",
    true,
    false,
    onSuccess,
    onError
  );
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div style={styles.mainContainer}>
      {isSuccuss ? (
        <>
          <div style={isDesktop ? styles.gridView : styles.gridViewMobile}>
            {data.data?.navbar
              .filter((d) => d.id !== 5 && d.id !== 6)
              .map((x) => (
                <div key={x.id} className="rectangle">
                  <div
                    className="top-rectangle"
                    style={{ backgroundColor: theme.palette.primary.main }}
                  >
                    {isDesktop ? (
                      <h1>{generateType(x.name)}</h1>
                    ) : (
                      <h5>{generateType(x.name)}</h5>
                    )}
                  </div>
                  <div
                    className="upper-rectangle"
                    style={
                      isDesktop
                        ? { backgroundColor: "#efefef" }
                        : { backgroundColor: "#efefef", fontSize: "small" }
                    }
                  >
                    <span>{currencyType(x.name)}</span>
                    <span>{"  "} </span>
                    <span>{x.value.toLocaleString()}</span>
                  </div>
                </div>
              ))}
          </div>

          <div
            style={
              isDesktop
                ? styles.currencyGridView
                : styles.currencyGridViewMobile
            }
          >
            {/* <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div>
                <Paper>
                  <TableContainer
                    component={Paper}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "fit-content",
                    }}
                  >
                    <Table
                      aria-label="simple table"
                      sx={isDesktop ? { width: "40vw" } : null}
                    >
                      <TableHead>
                        <TableRow>
                          {tblRow1.map(
                            (x, idx) => (
                              <TableCell
                                className="ratesTh"
                                key={idx}
                                align="right"
                              >
                                {x}
                              </TableCell>
                            )
                            // <th className='th' key={idx}>{x}</th>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.data.middle_table
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          ?.map((x, index) => (
                            <TableRow
                              className="ratesTr"
                              key={index}
                              sx={{
                                "&:last-child , &:last-child": { border: 0 },
                              }}
                            >
                              <TableCell className="ratesTd" align="right">
                                <span
                                  className={`fi fi-${getCountry(x.code)}`}
                                ></span>{" "}
                                {x.code}
                              </TableCell>
                              <TableCell className="ratesTd" align="right">
                                {x.currency}
                              </TableCell>
                              <TableCell className="ratesTd" align="right">
                                {x.buy}
                              </TableCell>
                              <TableCell className="ratesTd" align="right">
                                {x.sell}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    labelRowsPerPage={"تعداد سطر ها"}
                    component="div"
                    count={data.data.middle_table.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </div>
            </div> */}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div>
                <TableContainer
                  component={Paper}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "fit-content",
                  }}
                >
                  <Table aria-label="simple table" sx={{ width: "60vw" }}>
                    <TableHead>
                      <TableRow>
                        {tblRow2.map(
                          (x, idx) => (
                            <TableCell
                              className="ratesTh"
                              key={idx}
                              align="right"
                            >
                              {x}
                            </TableCell>
                          )
                          // <th className='th' key={idx}>{x}</th>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.data.bottom_table?.map((x, index) => (
                        <TableRow
                          className="ratesTr"
                          key={index}
                          sx={{ "&:last-child , &:last-child": { border: 0 } }}
                        >
                          <TableCell className="ratesTd" align="right">
                            {x.gold_Coins}
                          </TableCell>
                          <TableCell className="ratesTd" align="right">
                            {x.buy}
                          </TableCell>
                          <TableCell className="ratesTd" align="right">
                            {x.sell}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}

export default Bonbast;
